import { render } from "./ProductEdit.vue?vue&type=template&id=30fcd7a2&scoped=true"
import script from "./ProductEdit.vue?vue&type=script&lang=js"
export * from "./ProductEdit.vue?vue&type=script&lang=js"

import "./ProductEdit.vue?vue&type=style&index=0&id=30fcd7a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fcd7a2"]])

export default __exports__